import { Component, h, Host, Prop } from '@stencil/core';

export type TagVariant = 'error' | 'warning' | 'success' | 'information';

@Component({
  tag: 'uui-tag',
  styleUrl: 'uui-tag.css',
  shadow: true
})
export class UuiTag {
  /**
   * The tag variant.
   */
  @Prop({ reflect: true }) variant: TagVariant;

  render() {
    return (
      <Host>
        <div>
          <span><slot /></span>
        </div>
      </Host>
    );
  }
}
